import React from "react";

import { useTranslation } from "react-i18next";
import {
	FrontendOrder,
	FrontendUserInfo,
	RosterUserInfo,
} from "node-library/dist/portal";

import {
	ApprovalStatus,
	OrderStatus,
	UserStatus,
	UserType,
} from "node-library/dist/constants";

import { getStatusColors, getStatusString } from "../../../helpers/orderHelper";
import { roleMeetsRequirement } from "node-library/dist/helpers/request_helper";
import {
	COAIcon,
	DeleteIcon,
	EditIcon,
	ViewResultIcon,
} from "../../../common-components/svgIcons";
import { NeutralColor } from "node-library/dist/colors";
import { KebabDropdownButton } from "../../../common-components/button";
import { Card } from "@mui/material";
import {
	getUserStatusColors,
	getUserStatusString,
} from "../../../helpers/userHelper";

import { formatCustomDate } from "node-library/dist/helpers/date_helper";

interface Props {
	user: RosterUserInfo;
	goToViewUserDetails: () => void;
	// discardUnstartedOrder: () => void;
}

export default function UserCell(props: Props) {
	const { t: translation } = useTranslation();

	const {
		goToViewUserDetails,
		user,
		// discardUnstartedOrder,
	} = props;

	let userStatus: UserStatus;
	if (user.approvalStatus === ApprovalStatus.APPROVED && !user.emailValidated) {
		userStatus = UserStatus.VALIDATING_EMAIL;
	} else {
		userStatus = UserStatus.REGISTERED;
	}

	const statusString: string = getUserStatusString(userStatus, translation);

	const statusColor: {
		backgroundColor: string;
		borderColor: string;
		textColor: string;
	} = getUserStatusColors(userStatus);

	let actionOptions: Array<{
		key: string;
		onClick: () => void;
		children: React.ReactNode;
	}>;

	const userIsAdmin: boolean = user
		? roleMeetsRequirement(user?.role, UserType.ENGINEER)
		: false;

	// switch (order.orderStatus) {
	// 	case OrderStatus.INCOMPLETE:
	// 		actionOptions = [
	// 			{
	// 				key: `edit-batch-${order.orderBarcodeId}`,
	// 				onClick: () => {
	// 					editOrder();
	// 				},
	// 				children: (
	// 					<div className="icon-dropdown-menu-item">
	// 						<EditIcon strokeColor={NeutralColor.NEUTRAL_GREY_900} />
	// 						{translation("Edit")}
	// 					</div>
	// 				),
	// 			},
	// 			{
	// 				key: `delete-order-${order.orderBarcodeId}`,
	// 				onClick: () => {
	// 					discardUnstartedOrder();
	// 				},
	// 				children: (
	// 					<div className="icon-dropdown-menu-item">
	// 						<DeleteIcon />
	// 						{translation("Delete")}
	// 					</div>
	// 				),
	// 			},
	// 		];
	// 		break;
	// 	case OrderStatus.PENDING:
	// 		actionOptions = [
	// 			...(userIsAdmin
	// 				? [
	// 						{
	// 							key: `edit-batch-${order.orderBarcodeId}`,
	// 							onClick: () => {
	// 								editOrder();
	// 							},
	// 							children: (
	// 								<div className="icon-dropdown-menu-item">
	// 									<EditIcon strokeColor={NeutralColor.NEUTRAL_GREY_900} />
	// 									{translation("Edit")}
	// 								</div>
	// 							),
	// 						},
	// 				  ]
	// 				: []),
	// 			{
	// 				key: `delete-order-${order.orderBarcodeId}`,
	// 				onClick: () => {
	// 					discardUnstartedOrder();
	// 				},
	// 				children: (
	// 					<div className="icon-dropdown-menu-item">
	// 						<DeleteIcon />
	// 						{translation("Delete")}
	// 					</div>
	// 				),
	// 			},
	// 			{
	// 				key: `view-coa-order-${order.orderBarcodeId}`,
	// 				onClick: () => {
	// 					viewCOA();
	// 				},
	// 				children: (
	// 					<div className="icon-dropdown-menu-item">
	// 						<COAIcon />
	// 						{translation("ViewChainOfCustody")}
	// 					</div>
	// 				),
	// 			},
	// 		];
	// 		break;
	// 	case OrderStatus.IN_PROGRESS:
	// 		actionOptions = [
	// 			...(userIsAdmin
	// 				? [
	// 						{
	// 							key: `edit-batch-${order.orderBarcodeId}`,
	// 							onClick: () => {
	// 								editOrder();
	// 							},
	// 							children: (
	// 								<div className="icon-dropdown-menu-item">
	// 									<EditIcon strokeColor={NeutralColor.NEUTRAL_GREY_900} />
	// 									{translation("Edit")}
	// 								</div>
	// 							),
	// 						},
	// 						// {
	// 						// 	key: `delete-order-${order.orderBarcodeId}`,
	// 						// 	onClick: () => {
	// 						// 		deleteOrder();
	// 						// 	},
	// 						// 	children: (
	// 						// 		<div className="icon-dropdown-menu-item">
	// 						// 			<DeleteIcon />
	// 						// 			{translation("Delete")}
	// 						// 		</div>
	// 						// 	),
	// 						// },
	// 				  ]
	// 				: []),

	// 			{
	// 				key: `view-coa-order-${order.orderBarcodeId}`,
	// 				onClick: () => {
	// 					viewCOA();
	// 				},
	// 				children: (
	// 					<div className="icon-dropdown-menu-item">
	// 						<COAIcon />
	// 						{translation("ViewChainOfCustody")}
	// 					</div>
	// 				),
	// 			},
	// 			{
	// 				key: `view-result-order-${order.orderBarcodeId}`,
	// 				onClick: () => {
	// 					viewResult();
	// 				},
	// 				children: (
	// 					<div className="icon-dropdown-menu-item">
	// 						<ViewResultIcon />
	// 						{translation("ViewResult")}
	// 					</div>
	// 				),
	// 			},
	// 		];
	// 		break;
	// 	case OrderStatus.COMPLETE:
	// 		actionOptions = [
	// 			...(userIsAdmin
	// 				? [
	// 						{
	// 							key: `edit-batch-${order.orderBarcodeId}`,
	// 							onClick: () => {
	// 								editOrder();
	// 							},
	// 							children: (
	// 								<div className="icon-dropdown-menu-item">
	// 									<EditIcon strokeColor={NeutralColor.NEUTRAL_GREY_900} />
	// 									{translation("Edit")}
	// 								</div>
	// 							),
	// 						},
	// 						// {
	// 						// 	key: `delete-order-${order.orderBarcodeId}`,
	// 						// 	onClick: () => {
	// 						// 		deleteOrder();
	// 						// 	},
	// 						// 	children: (
	// 						// 		<div className="icon-dropdown-menu-item">
	// 						// 			<DeleteIcon />
	// 						// 			{translation("Delete")}
	// 						// 		</div>
	// 						// 	),
	// 						// },
	// 				  ]
	// 				: []),

	// 			{
	// 				key: `view-coa-order-${order.orderBarcodeId}`,
	// 				onClick: () => {
	// 					viewCOA();
	// 				},
	// 				children: (
	// 					<div className="icon-dropdown-menu-item">
	// 						<COAIcon />
	// 						{translation("ViewChainOfCustody")}
	// 					</div>
	// 				),
	// 			},
	// 			{
	// 				key: `view-result-order-${order.orderBarcodeId}`,
	// 				onClick: () => {
	// 					viewResult();
	// 				},
	// 				children: (
	// 					<div className="icon-dropdown-menu-item">
	// 						<ViewResultIcon />
	// 						{translation("ViewResult")}
	// 					</div>
	// 				),
	// 			},
	// 		];
	// 		break;
	// }

	const userHeaderRow: React.ReactNode = (
		<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				gap: "5px",
			}}
		>
			<div
				className="typography-caption sample-status-box"
				style={{
					backgroundColor: statusColor.backgroundColor,
					border: `1px solid ${statusColor.borderColor}`,
					color: statusColor.textColor,
				}}
			>
				{statusString}
			</div>

			{/* <KebabDropdownButton
				menuOptions={actionOptions}
				id={`batch-more-action-menu-${order.orderBarcodeId}`}
				onClick={(e) => {}}
			></KebabDropdownButton> */}
		</div>
	);
	const userBody: React.ReactNode = (
		<div
			style={{
				marginTop: "10px",
				display: "flex",
				flexDirection: "column",
				gap: "5px",
			}}
		>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("Username")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{user.userName}
				</div>
			</div>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("FirstName")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{user.firstName}
				</div>
			</div>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("LastName")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{user.lastName}
				</div>
			</div>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("RegistrationTime")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{formatCustomDate(user.inserted as Date)}
				</div>
			</div>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("CompanyName")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{user.clientCompanyName}
				</div>
			</div>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">{translation("Role")}</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{user.role}
				</div>
			</div>
		</div>
	);

	return (
		<Card
			className="card-border-radius-14p card-medium-padding highlight-card"
			style={{ cursor: "pointer" }}
			key={user.userId}
			onClick={() => {
				goToViewUserDetails();
			}}
		>
			{userHeaderRow}
			{userBody}
		</Card>
	);
}
